import dayjs from 'dayjs';

import { DATE_FORMAT } from '#client/constants/date';

// 100000 => $100,000.00
export function formatMoneyDisplay(number, maximumFractionDigits, minimumFractionDigits) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits,
    minimumFractionDigits
  });
  return formatter.format(number);
}

// 100000 => 100,000
export function formatCommaNumber(textNumber) {
  return textNumber.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getPureNumber(textNumber) {
  return textNumber.replace(/,/g, '');
}

export function convertCentToDollar(value) {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return 0;
  }

  return value / 100;
}

export const getNextMonth = () => {
  const now = new Date();
  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  return dayjs(nextMonth).format(DATE_FORMAT.MOVE_MONEY);
};
